export * from './GradientTypography'
